"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLatLng = exports.geojson = void 0;
const turf_1 = require("@turf/turf");
const geojson = (latLng) => {
    return latLng && latLng.lat() && latLng.lng() ? (0, turf_1.point)([latLng.lng(), latLng.lat()], {}) : undefined;
};
exports.geojson = geojson;
const toLatLng = (feature) => {
    return new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
};
exports.toLatLng = toLatLng;
//# sourceMappingURL=GoogleMapUtils.js.map